(() => {
  'use strict';
  const moveSizeGuide = () => {
    for (const details of document.querySelectorAll('.product-details')) {
      const fieldset = [...details.querySelectorAll('variant-picker fieldset')].find(el => /talla|size|tamaño/i.test(el.querySelector('legend')?.textContent || ''));
      const legend = fieldset?.querySelector('legend');
      const guide = details.querySelector('.ks-chart-modal-link');
      if (!legend || !guide || legend.contains(guide)) continue;
      legend.classList.add('iq-size-legend');
      guide.classList.add('iq-size-guide');
      if (!guide.hasAttribute('tabindex')) guide.tabIndex = 0;
      if (!guide.hasAttribute('role')) guide.setAttribute('role', 'button');
      if (!guide.dataset.iqAccessible) {
        guide.dataset.iqAccessible = 'true';
        guide.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            guide.click();
          }
        });
      }
      legend.append(guide);
    }
  };
  moveSizeGuide();
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; moveSizeGuide(); });
  });
  for (const details of document.querySelectorAll('.product-details')) observer.observe(details, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', moveSizeGuide);

  const section = document.querySelector('[data-iq-recent]');
  if (!section) return;
  const key = 'iq_recent_products_v1';
  let previous = [];
  try {
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) previous = [...new Set(saved.filter(handle => typeof handle === 'string' && /^[a-z0-9-]{1,200}$/.test(handle)))];
    localStorage.setItem(key, JSON.stringify([section.dataset.current, ...previous.filter(handle => handle !== section.dataset.current)].slice(0,12)));
  } catch {}
  const handles = previous.filter(handle => handle !== section.dataset.current).slice(0,4);
  if (!handles.length) return;
  const root = section.dataset.root.replace(/\/?$/, '/');
  const grid = section.querySelector('[data-iq-recent-grid]');
  const currency = section.dataset.currency || 'EUR';
  const price = new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency', currency});
  const makeCard = product => {
    const article = document.createElement('article');
    article.className = 'iq-card';
    const url = root + 'products/' + encodeURIComponent(product.handle);
    const media = document.createElement('a');
    media.className = 'iq-card__media';
    media.href = url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    const src = product.featured_image || product.images?.[0];
    if (src) {
      const imageUrl = new URL(src, location.origin);
      if (imageUrl.protocol === 'https:') {
        imageUrl.searchParams.set('width','600');
        const image = document.createElement('img');
        image.src = imageUrl.href;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 600;
        image.height = 750;
        image.className = 'iq-card__img';
        media.append(image);
      }
    }
    const body = document.createElement('div');
    body.className = 'iq-card__body';
    const heading = document.createElement('h3');
    heading.className = 'iq-card__title';
    const link = document.createElement('a');
    link.href = url;
    link.textContent = product.title;
    heading.append(link);
    const amount = document.createElement('p');
    amount.className = 'iq-card__price';
    amount.textContent = price.format(product.price / 100);
    body.append(heading, amount);
    article.append(media, body);
    return article;
  };
  const load = async () => {
    const results = await Promise.allSettled(handles.map(async handle => {
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return null;
      const product = await response.json();
      return product && product.handle && product.title ? product : null;
    }));
    for (const result of results) if (result.status === 'fulfilled' && result.value) grid.append(makeCard(result.value));
    if (grid.children.length) section.hidden = false;
  };
  if ('IntersectionObserver' in window) {
    const trigger = document.createElement('div');
    section.before(trigger);
    const lazy = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      lazy.disconnect();
      trigger.remove();
      load();
    }, {rootMargin:'700px'});
    lazy.observe(trigger);
  } else load();
})();
